module.exports = __webpack_public_path__ + "static/com_3-bf2bdcea5d2ca8ab7edb50b51d8cc9f5.png";